import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { AiOutlineLineChart } from 'react-icons/ai';
import CollectionItemHeader from '../layout/CollectionItemHeader';
import getTheme from '../../theme/theme';
import { useItems } from '../../hooks/atoms/items-hook';
import CollectionKeys from '../../hooks/molecules/collection-keys';
import AppLoader from '../basic/AppLoader';
import UpgradedKitsTable from './upgraded-kits/UpgradedKitsTable';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: theme.spacing(0, 1),
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: theme.spacing(1),
    },
    demo: {
      backgroundColor: '#f0f0f0',
      alignItems: 'center',
      marginLeft: '5%',
      marginRight: '5%',
    },
  };
});

const UpgradedKits = () => {
  const classes = useStyles();

  const {
    itemsLoading: kitsLoading,
    count: totalEntries,
  } = useItems(CollectionKeys.REGISTRATION_KITS, { filterQuery: { _limit: 1 } }, {
    _where: [
      { _or: [
        [{ 'serial_number_id.report_payment_status_eq': 'paid' }],
        [{ 'serial_number_id.report_payment_status_eq': 'free' }],
      ] },
    ],
    'serial_number_id.ancestor_null': false,
  });

  if (kitsLoading) {
    return <AppLoader />;
  }

  return (
    <div className={ classes.root }>
      <div style={ { display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: getTheme().spacing(2) } }>
        <AiOutlineLineChart
          style={ { color: getTheme().palette.secondary.dark, marginRight: getTheme().spacing(2) } }
          size={ 36 }
        />
        <CollectionItemHeader
          title='Upgraded kits'
          subtitle={ `Entries: ${ totalEntries ?? 0 }` }
          actions={ (
            <>
            </>
          ) }
        />
      </div>
      <UpgradedKitsTable />
    </div>
  );
};

export default UpgradedKits;
